import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const TestAdmin = () => {
  const { user, userProfile } = useAuth();

  const handleSetupAdmin = async () => {
    try {
      const response = await fetch('/api/setup-admin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: user?.email }),
      });
      
      if (response.ok) {
        alert('Admin role set successfully! Please refresh the page.');
        window.location.reload();
      } else {
        alert('Failed to set admin role. Check console for details.');
      }
    } catch (error) {
      console.error('Error setting up admin:', error);
      alert('Error setting up admin role.');
    }
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <Icon name="Settings" size={24} />
              <span>Admin Setup Test</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <h3 className="font-medium mb-2">Current User Info:</h3>
              <p><strong>Email:</strong> {user?.email || 'Not logged in'}</p>
              <p><strong>Role:</strong> {userProfile?.role || 'Unknown'}</p>
              <p><strong>Is Admin:</strong> {userProfile?.role === 'admin' ? 'Yes' : 'No'}</p>
            </div>
            
            {userProfile?.role !== 'admin' && (
              <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p className="text-yellow-800 mb-2">
                  You need admin privileges to access the occupation updates page.
                </p>
                <Button onClick={handleSetupAdmin}>
                  Set Admin Role (Temporary)
                </Button>
                <p className="text-sm text-yellow-600 mt-2">
                  Note: This is a temporary setup. In production, admin roles should be set directly in the database.
                </p>
              </div>
            )}
            
            {userProfile?.role === 'admin' && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-800 mb-2">
                  ✅ You have admin privileges! You can now access the occupation updates page.
                </p>
                <Button asChild>
                  <a href="/admin/occupation-updates">
                    Go to Occupation Updates
                  </a>
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TestAdmin;
